<template>
  <h1
    class="u-title"
    data-anim="title"
    v-html="data"
  />
</template>

<script>
export default {
  name: 'appTitle',

  props: {
    data: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.u-title {
  @include fluid-type(
    375px,
    1920px,
    25px,
    100px,
    30px,
    100px
  );
}
</style>
